<div class="modal-content">
  <div class="modal-header align-items-center">
    <div class="d-flex flex-column">
      <h2 class="modal-title mb-1">{{ 'results.enterResult' | translate }}</h2>
      <p class="text-muted small mb-0">{{ eventClass.class_name }} - {{ round.round_name || 'Round ' + round.round_number }}</p>
    </div>
    <i class="fa-solid fa-xmark fs-2 cursor-pointer" (click)="close()"></i>
  </div>

  <div class="modal-body">
    @if (loading) {
      <div class="text-center py-4">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
    } @else {
      <!-- Participant Info -->
      <div class="participant-info mb-4">
        <div class="participant-name">{{ participantName }}</div>
        @if (horseName) {
          <div class="horse-name">
            <i class="fa fa-horse me-1"></i>
            {{ horseName }}
          </div>
        }
      </div>

      <form [formGroup]="form">
        <!-- Status Selection -->
        <div class="status-selection mb-4">
          <label class="form-label fw-semibold">{{ 'results.status' | translate }}</label>
          <div class="status-buttons">
            @for (option of statusOptions; track option.value) {
              <button
                type="button"
                class="btn btn-sm"
                [class.btn-primary]="form.get('status')?.value === option.value"
                [class.btn-outline-secondary]="form.get('status')?.value !== option.value"
                (click)="form.get('status')?.setValue(option.value)"
              >
                {{ option.labelKey | translate }}
              </button>
            }
          </div>
        </div>

        <!-- Time Input (for timed/combined) -->
        @if (isTimeBased && form.get('status')?.value === 'recorded') {
          <div class="mb-4">
            <app-input-component
              [label]="'results.rawTime' | translate"
              [type]="'number'"
              [value]="form.get('raw_time_seconds')?.value"
              (valueChange)="form.get('raw_time_seconds')?.setValue($event)"
              [floating]="true"
              [placeholder]="'0.000'"
            ></app-input-component>
            <small class="text-muted">{{ 'results.timeInSeconds' | translate }}</small>
          </div>
        }

        <!-- Points Input (for points/combined) -->
        @if (isPointsBased && form.get('status')?.value === 'recorded') {
          <div class="mb-4">
            <app-input-component
              [label]="'results.rawPoints' | translate"
              [type]="'number'"
              [value]="form.get('raw_points')?.value"
              (valueChange)="form.get('raw_points')?.setValue($event)"
              [floating]="true"
              [placeholder]="'0'"
            ></app-input-component>
          </div>
        }

        <!-- Penalty Input -->
        @if (form.get('status')?.value === 'recorded') {
          <div class="mb-4">
            <app-input-component
              [label]="getPenaltyLabel()"
              [type]="'number'"
              [value]="form.get('penalty_total')?.value"
              (valueChange)="form.get('penalty_total')?.setValue($event)"
              [floating]="true"
              [placeholder]="'0'"
            ></app-input-component>
            <small class="text-muted">{{ getPenaltyHint() }}</small>
          </div>
        }

        <!-- Notes -->
        <div class="mb-3">
          <label class="form-label">{{ 'results.notes' | translate }}</label>
          <textarea
            class="form-control"
            formControlName="notes"
            rows="2"
            [placeholder]="'results.notes' | translate"
          ></textarea>
        </div>

        <!-- Images Section -->
        @if (existingResult) {
          <div class="images-section mb-3">
            <label class="form-label fw-semibold">{{ 'images.resultImages' | translate }}</label>
            <div class="images-list">
              @for (img of resultImages; track img.image_id) {
                <div class="image-item">
                  <img [src]="img.image_url" [alt]="img.image_name" class="image-thumbnail" (click)="viewImage(img)">
                  <span class="image-name">{{ img.image_name }}</span>
                  <button type="button" class="btn-remove-image" (click)="deleteImage(img)">
                    <i class="fa fa-times"></i>
                  </button>
                </div>
              }
            </div>
            <div class="image-upload mt-2">
              <input type="file" id="imageInput" class="d-none" accept="image/*" (change)="onFileSelected($event)">
              <label for="imageInput" class="btn btn-light-primary btn-sm" [class.disabled]="uploadingImage">
                @if (uploadingImage) {
                  <span class="spinner-border spinner-border-sm me-2"></span>
                } @else {
                  <i class="fa fa-image me-2"></i>
                }
                {{ 'images.addImage' | translate }}
              </label>
            </div>
          </div>
        }
      </form>
    }
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-light me-2" (click)="close()">
      {{ 'common.cancel' | translate }}
    </button>
    <button
      type="button"
      class="btn btn-primary"
      (click)="save()"
      [disabled]="saving || loading"
    >
      @if (saving) {
        <span class="spinner-border spinner-border-sm me-2" role="status"></span>
      }
      {{ 'results.saveResult' | translate }}
    </button>
  </div>
</div>
